import { render, staticRenderFns } from "./LeaveSummaryReportTable.vue?vue&type=template&id=5bf998c7"
import script from "./LeaveSummaryReportTable.vue?vue&type=script&lang=js"
export * from "./LeaveSummaryReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports